
mutation setPurchaseDate($start_date: String) {
    setPurchaseDate(start_date: $start_date)
}
